const headers = [
  {
    text: 'id',
    value: 'suggestedReceivingLocationId',
    sortable: true,
    width: '2%'
  },
  {
    text: 'order.order_suggested-receiving-location',
    value: 'location',
    sortable: true,
    width: '29%'
  },
  {
    text: 'common.address_address_0',
    value: 'address',
    sortable: true,
    width: '29%'
  },
  {
    text: 'storage.storage_contact-address',
    value: 'phoneNumber',
    sortable: true,
    width: '22%'
  },
  {
    text: 'common.input_sort-number',
    value: 'sortNumber',
    sortable: true,
    width: '9%'
  },
  {
    text: 'payment.payment_operation',
    value: 'editAndDelete',
    sortable: false,
    width: '13%'
  }
]
export default { headers }
